<template>
  <div class="fade-in">

    <!-- Header -->
    <div>
      <div class="container goals-header">
        <!-- <h1>{{$t('goals.pageTitle')}}</h1> -->
        <h5>{{$t('goals.pageSubtitle')}}</h5>
      </div>
    </div>

    <!-- Global goal selection -->
    <div class="project-section">
      <div class="columns">
        <div class="column flex-align-center is-hidden-mobile is-hidden-tablet-only" style="padding: 0;">
          <!-- <scenarios v-if="getProject.scenarios.length > 1 || getActiveGoal.code"></scenarios> -->
        </div>
        <div class="goal-wheel-container column is-6-desktop is-5-tablet flex-justify-content-center">
          <div class="goal-wheel">
            <wheel @goToTargets="goToTargets" @goalClicked="selectedGoals" :class="[getWheelVisible ? 'opacity-full': 'opacity-none']" :selectedGoals="getSelectedGoals" :mode="'select'" :showGoalsImmediately="true" :view="currentState" :showIcons="true" :useComponentButton="'true'" ref="goalWheel" :name="'goals'"></wheel>
          </div>
        </div>
        <div class="column flex-align-center" style="min-width: 470px;">
          <book></book>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import wheel from './../shared/sdg-wheel/sdg-wheel.vue'
// import scenarios from './../shared/scenarios/scenarios.vue'
import book from './../shared/goal-book/goal-book.vue'

export default {
  name: 'goals',
  components: {
    wheel,
    // scenarios,
    book
  },
  data () {
    return {
      uploadProject: 'file'
    }
  },
  props: {
    currentState: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      getProject: 'getProject',
      getSelectedGoals: 'getSelectedGoals',
      getWheelVisible: 'getWheelVisible',
      getActiveGoal: 'getActiveGoal',
      getTargetList: 'getTargetList'
    })
  },
  watch: {
    currentState (val, oldVal) {
      if (val === 'goals') {
        this.$nextTick(() => {
          this.$emit('goTo2')
        })
      }
    }
  },
  methods: {
    ...mapActions({
      setGoalWheel: 'setGoalWheel',
      setSelectedGoals: 'setSelectedGoals',
      setTargetList: 'setTargetList',
      setActiveGoal: 'setActiveGoal'
    }),
    goToTargets () {
      new Promise((resolve, reject) => {
        if (this.getTargetList.length < 1) {
          resolve(this.setTargetList())
        } else {
          resolve(this.setActiveGoal(this.getSelectedGoals[0]))
        }
      }).then(() => {
        this.$emit('goTo', 'targets')
      })
    },
    selectedGoals (goal) {
      this.setSelectedGoals(goal)
    }
  }
}
</script>
